let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gqSrT")).then(() => parcelRequire('iaF1N'));